import * as Yup from "yup";


export const scheduleUpdateSchema = Yup.object().shape({
  eventType: Yup.object().shape({
    label: Yup.string().required("Required"),
    value: Yup.string().required("Required"),
  }),
  group: Yup.object().shape({
    label: Yup.string().required("Required"),
    value: Yup.string().required("Required"),
  }),
  frequency: Yup.object().shape({
    label: Yup.string().required("Required"),
    value: Yup.string().required("Required"),
  }),
  subject: Yup.string().required("Required"),
  from: Yup.string().required("Required"),
  message: Yup.string().required("Required"),
});
